var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"headers":_vm.headers,"items":_vm.userEvents},scopedSlots:_vm._u([{key:"item.Start_Date",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(new Date(item.Start_Date).toLocaleDateString('en-us', {year:"numeric", month:"short", day:"numeric"})))])]}},{key:"item.End_Date",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(new Date(item.End_Date).toLocaleDateString('en-us', {year:"numeric", month:"short", day:"numeric"})))])]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }